<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="add-email-sms-template-popup">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add an Email & SMS Template</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">

      <div class="row mb-2">
        <div class="col-4">
          <label for="emailTemplate"><strong>Mail template</strong></label>
        </div>
        <div class="col">
          <input type="text" id="emailTemplate" autocomplete="off"
                 class="form-control w-100 mb-2"
                 formControlName="templateName" [ngClass]="{
                    'form-required-border':
                      form.get('templateName').invalid &&
                      (form.get('templateName').dirty ||
                        form.get('templateName').touched)
                  }" />


          <mat-checkbox class="me-1" formControlName="default"></mat-checkbox><mat-label class="me-2">Default</mat-label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4">
          <label for="subject"><strong>Email Subject Line</strong></label>
        </div>
        <div class="col">
          <input type="text" id="subject" autocomplete="off"
                 class="form-control w-100 mb-2"
                 formControlName="subject" />

        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4">
          <label for="emailBody"><strong>Email Body Text</strong></label>
        </div>
        <div class="col">
          <textarea class="form-control" formControlName="emailBodyText" id="emailBody" rows="6"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label for="smsBody"><strong>Sms Body Text</strong></label>
        </div>
        <div class="col">
          <textarea class="form-control" formControlName="smsBodyText" id="smsBody" rows="3"></textarea>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <div class="text-end">
        <button type="submit" [disabled]="form.invalid" class="btn btn-primary float-end me-3 mb-3">
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </div>
  </div>
</form>
